// PODIUM (§6.6): the Lobby lid with three pedestals that are both solid circles (top = height)
// and raised ground. Spawns 0–2 are the 1st/2nd/3rd pedestals; the rest stand around them.
import { TUNE, VOID } from '../constants';
import { MapId } from '../ids';
import { MAP_TEMPO } from './clock';
import { circleSolid, copySolids, nearSolid, neutralHazardPose } from './common';
import { inDisc, inRoundedRect, nearestOnRoundedRect } from './geometry';
import { LID } from './lid';
import { SolidTag, type MapDef } from './mapTypes';

export const TUNING = {
  /** 1st, 2nd, 3rd. */
  pedestals: [
    { x: 0, y: -1, r: 1.2, height: 0.9 },
    { x: -2.6, y: -0.6, r: 1.1, height: 0.65 },
    { x: 2.6, y: -0.6, r: 1.1, height: 0.4 },
  ],
  others: [{ x: -5, y: 1.2 }, { x: -2.5, y: 2.0 }, { x: 0, y: 2.6 }, { x: 2.5, y: 2.0 }, { x: 5, y: 1.2 }],
} as const;

/** Number of pedestal spawns at the front of `PODIUM.spawns`. */
export const PEDESTAL_COUNT = TUNING.pedestals.length;

const SOLIDS = TUNING.pedestals.map((p, i) => circleSolid(p.x, p.y, p.r, p.height, TUNE.body.restitution, SolidTag.NONE, i));

export const PODIUM: MapDef = {
  id: MapId.PODIUM,
  name: 'Podium',
  tpb: MAP_TEMPO[MapId.PODIUM].tpb,
  tpbSD: MAP_TEMPO[MapId.PODIUM].tpbSD,
  bounds: { minX: LID.cx - LID.hx, maxX: LID.cx + LID.hx, minY: LID.cy - LID.hy, maxY: LID.cy + LID.hy },
  spawns: [...TUNING.pedestals, ...TUNING.others].map((p) => ({ x: p.x, y: p.y })),
  voidKind: 'lilac',
  center: { x: 0, y: 0 },
  initState() {},
  groundAt(_w, x, y) {
    if (!inRoundedRect(x, y, LID)) return VOID;
    let h = 0;
    for (const p of TUNING.pedestals) if (p.height > h && inDisc(x, y, p.x, p.y, p.r)) h = p.height;
    return h;
  },
  nearestGround(_w, x, y, out) {
    return nearestOnRoundedRect(x, y, LID, out);
  },
  solids(_w, out) {
    return copySolids(SOLIDS, out);
  },
  onSolidContact() {},
  step() {},
  danger() {
    return 0;
  },
  hazardPose(_w, _tick, out) {
    return neutralHazardPose(out);
  },
  crateExclusion(_w, x, y) {
    return nearSolid(SOLIDS, x, y, TUNE.crate.radius);
  },
};
